export const requestConst = {
    REQUESTS_SET_EVENT: 'REQUESTS_SET_EVENT',

    CATEGORIES_REQUEST: 'CATEGORIES_REQUEST',
    CATEGORIES_SUCCESS: 'CATEGORIES_SUCCESS',
    CATEGORIES_FAILURE: 'CATEGORIES_FAILURE',

    REQUESTS_START_REQUEST: 'REQUESTS_START_REQUEST',
    REQUESTS_END_REQUEST: 'REQUESTS_END_REQUEST',
    REQUESTS_SUCCESS: 'REQUESTS_SUCCESS',
    REQUESTS_FAILURE: 'REQUESTS_FAILURE',

    CLEAR_ERRORS: 'REQUEST_CLEAR_ERRORS',

    CLEAR: 'REQUEST_CLEAR'
};
